// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"2e9d3564","143":"01b98bdc","230":"aa958d82","558":"a408a2ee","969":"5f9ee99e"}[chunkId] + ".chunk.js";
};